<template>
  <main class="pt-24">
    <section id="home">
     <InicioCase />
     <Fase2Page />
    </section>

    <section id="funcionalidades">
     <Fase3Page />
     <Fase4Page />
     <Fase5Page />
    </section>

    <section id="sobrenos">
     <Fase6Page />
    </section>

    <section id="informacoes">
      <Fase7Page />
    </section>

    <section id="experimente">
        <FaqPage />
    </section>
  </main>
</template>

<script>
import Fase2Page from '@/components/Cases/Fase2Page.vue';
import Fase3Page from '@/components/Cases/Fase3Page.vue';
import InicioCase from '@/components/Cases/InicioCase.vue';
import Fase4Page from '@/components/Cases/Fase4Page.vue';
import Fase5Page from '@/components/Cases/Fase5Page.vue';
import Fase6Page from '@/components/Cases/Fase6Page.vue';
import Fase7Page from '@/components/Cases/Fase7Page.vue';
import FaqPage from '@/components/FAQ/FaqPage.vue';
export default {
  name: "HomePage",
  components: {
    InicioCase,
    Fase2Page,
    Fase3Page,
    Fase4Page,
    Fase5Page,
    Fase6Page,
    Fase7Page,
    FaqPage
  },
};
</script>